let isRtl = undefined;
function isPageRtl() {
    if (isRtl === undefined) {
        isRtl = false;
        if (document.documentElement.getAttribute("dir") === "rtl") {
            isRtl = true;
        }
    }
    return isRtl;
}
export default isPageRtl;
